import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Dr. Ishapathik Das",
        "NameLink": "/dr-ishapathik-das",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Technology Bombay, India.   ",
        "AreasofInterest": "Generalized Linear Models, Multivariate Distributions ",
        "Phone": " 0877 250 3350 / 3357",
        "Email": " hod_ma@iittp.ac.in / ishapathik@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/ishap.jpg"
    }
]
const Faculty = [
    {
        "Name": "Prof. N. Balakrishna",
        "NameLink": "https://facweb.iittp.ac.in/~balakrishna/",
        "Position": "Professor ",
        "Degree": "Ph.D - University of Poona",
        "AreasofInterest": "Linear and non-linear Time Series Analysis,Financial time series, Modeling of Stochastic Volatility, Analysis of Repairable systems, Chaotic time series.",
        "Phone": "0877 250 3365",
        "Email": " bala@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof_N_%20Balakrishna.png"
    },
    {
        "Name": "Dr. Durga Prasad Challa",
        "NameLink": "/dr-durga-prasad-challa",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Johannes Kepler University & RICAM, Linz, Austria",
        "AreasofInterest": "Forward and Inverse Scattering Problems, Scientific Computing, Cloaking and Effective Medium Theories",
        "Phone": "0877 250 3355",
        "Email": "chsmdp@iittp.ac.in, durga.challa@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/durga1.jpg"
    },

    {
        "Name": "Dr. Panchatcharam Mariappan",
        "NameLink": "/dr-panchatcharam-mariappan",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IIT Madras, India & TU Kaiserslautern, Germany",
        "AreasofInterest": "Numerics for PDEs, Computational Fluid Dynamics.",
        "Phone": "0877 250 3358",
        "Email": "panch.m@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/PanchatcharamNUMA.jpg"
    },
    {
        "Name": "Dr. S.Rajesh",
        "NameLink": "/dr-s-rajesh",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IIT Madras, India",
        "AreasofInterest": "Metric Fixed Point Theory",
        "Phone": "0877 250 3359",
        "Email": "srajesh@iittp.ac.in",
        "WebPage": "https://sites.google.com/iittp.ac.in/srajesh-web-page",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr.Rajesh.jpg"
    },
    {
        "Name": "Dr. Srijanani Anurag Prasad",
        "NameLink": "/dr-srijanani-anurag-prasad",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "Fractals, Functional Equations",
        "Phone": "0877 250 3360",
        "Email": "srijanani@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/srijanani.jpg"
    },

  

    {
        "Name": "Dr. Ananya Lahiri",
        "NameLink": "/dr-ananya-lahiri",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IIT Kanpur, India",
        "AreasofInterest": "Statistics and Probability",
        "Phone": "0877 250 3356",
        "Email": "ananya@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Ananya.jpg"
    },

    {
        "Name": "Dr. Angshuman Roy",
        "NameLink": "/dr-angshuman-roy",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Statistical Institute, Kolkata",
        "AreasofInterest": "Multivariate statistics, Nonparametric statistics",
        "Phone": "0877 250 3364",
        "Email": "angshuman_roy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Angshuman_Roy_AP.jpg"
    },
    {
        "Name": "Dr. Anjana Mondal",
        "NameLink": "/dr-anjana-mondal",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IIT Kharagpur, Kharagpur, India",
        "AreasofInterest": "Design of Experiments, Order Restricted Statistical Inference",
        "Phone": "0877 250 3366",
        "Email": "anjanam@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Anjana_Mondal_AP.png"
    },

    {
        "Name": "Dr. Bidisha Roy",
        "NameLink": "/dr-bidisha-roy",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Harish-Chandra Research Institute (HBNI), India",
        "AreasofInterest": "Number Theory, Elliptic curves",
        "Phone": "0877 250 3362",
        "Email": "bidisha.roy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/bidisha_roy_AP.png"
    },
    


    {
        "Name": "Dr. Krishna Kishore",
        "NameLink": "/dr-krishna-kishore",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indiana University, Bloomington, Indiana, USA",
        "AreasofInterest": "Automorphic representations",
        "Phone": "0877 250 3363",
        "Email": "kishorekrishna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/kishore.png"
    },
    
    {
        "Name": "Dr. B Ravinder",
        "NameLink": "/dr-b-ravinder",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - The Institute of Mathematical Sciences, Chennai, India",
        "AreasofInterest": "Representation theory of Lie algebras, Combinatorics",
        "Phone": "0877 250 3361",
        "Email": "ravinder@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/bravinder.jpg"
    },
    
    {
        "Name": "Dr. Shilpak Banerjee",
        "NameLink": "/dr-shilpak-banerjee",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - The Pennsylvania State University, University Park, USA",
        "AreasofInterest": "Ergodic Theory, Dynamical Systems",
        "Phone": "0877 250 3367",
        "Email": "shilpak@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/shilpak.jpg"
    }





]



const VisitingFaculty = [


   



]


const GuestFaculty = [


    // {
    //     "Name": "Dr. Sudheesh Kumar Kattumannil",
    //     "NameLink": "#",
    //     "Position": "Associate Professor at ISI Chennai",
    //     "Degree": "Ph.D - Cochin University of Science and Technology, Koch",
    //     "AreasofInterest": "Survival analysis, Reliability theory,Variance inequality and moment identity,Estimation of income inequality measures,Measurement error problems,Empirical likelihood inference.",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/sudheesh_GF.jpg"
    // },

    {
        "Name": "Dr. GSR Murthy",
        "NameLink": "#",
        "Position": "Senior Technical Officer, ISI Hyderabad",
        "Degree": "Ph.D - Indian Statistical Institute, Kolkata",
        "AreasofInterest": "Operations research, Linear and semidefinite complementarity problems, , Statistics in industry.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/gsrmurthy_GF.jpg"
    },


    // {
    //     "Name": "Prof. Usha R",
    //     "NameLink": "#",
    //     "Position": "Professor, IIT Madras (Retired)",
    //     "Degree": "Ph.D - IIT Madras",
    //     "AreasofInterest": "Nonlinear Partial Differential Equations, Nonlinear Ordinary Differential Equations, Dynamical systems, Perturbation methods, Asymptotic methods and computing.",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/ushar_GF.jpg"
    // },



]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="MATHEMATICS AND STATISTICS" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>MATHEMATICS AND STATISTICS</h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={7} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((Faculty, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || Faculty.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{Faculty.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>





                            {/*--------------------------- Visiting Faculty*/}
                            {/* <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Visiting  Faculty</h3>
                                {VisitingFaculty.map((VisitingFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={VisitingFaculty.NameLink}>
                                                        <img src={VisitingFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={VisitingFaculty.NameLink}>{VisitingFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{VisitingFaculty.Position}</p>
                                                    <p className="text-dark">{VisitingFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {VisitingFaculty.AreasofInterest}</p>

                                                    {(VisitingFaculty.Phone !== undefined && VisitingFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{VisitingFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {VisitingFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}



                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

export default Main